import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'lean-card',
    templateUrl: './lean-card.component.html',
    styleUrls: ['./lean-card.component.scss']
})
export class LeanCard implements OnInit {


public _hideCloseButton = false;
@Input('hideCloseButton') 
    get hideCloseButton(): boolean {
    return this._hideCloseButton;
    }
    set hideCloseButton(value: boolean) {
    this._hideCloseButton = "" + value !== "false";
    }

public _fitContentMode = true;
@Input('fitContentMode') 
    get fitContentMode(): boolean {
    return this._fitContentMode;
    }
    set fitContentMode(value: boolean) {
    this._fitContentMode = "" + value !== "false";
    }

public _shrinkMode = false;
@Input('shrinkMode') 
    get shrinkMode(): boolean {
    return this._shrinkMode;
    }
    set shrinkMode(value: boolean) {
    this._shrinkMode = "" + value !== "false";
    }

public _allowShrink = false;
@Input('allowShrink') 
    get allowShrink(): boolean {
    return this._allowShrink;
    }
    set allowShrink(value: boolean) {
    this._allowShrink = "" + value !== "false";
    }    

public _showHeader = false;
@Input('showHeader') 
    get showHeader(): boolean {
    return this._showHeader;
    }
    set showHeader(value: boolean) {
    this._showHeader = "" + value !== "false";
    }    


    @Output() onSubmit   = new EventEmitter<any>();
    @Output() onClose    = new EventEmitter<any>();
    @Output() onExpand   = new EventEmitter<any>();

    @Input() width     : string;
    @Input() minHeight : string;
    
    @Input() borderTopColor : string;
    @Input() headerBackgroundColor : string;
    @Input() titleColor : string;
    
    

    @Input() submitLabel     : string = 'Fermer';

    @Input() actions = [];
    @Input() title = undefined;
    @Input() header = undefined;
    
    @Input() badge = undefined;
    @Input() showFooterWhen      : string  = "always"; // never, onOver 


    showCardActions : boolean = true;

    close(){
        this.onClose.emit(null);
    }

    ngOnInit() {
        if (this.showFooterWhen == 'always')   this.showCardActions = true;
        if (this.showFooterWhen == 'never')    this.showCardActions = false;
        if (this.showFooterWhen == 'onOver')   this.showCardActions = false;
    }   

    shrink(b : boolean){
        this.shrinkMode = b;
        this.onExpand.emit(! b);
    }


    mouseover(){
        if (this.showFooterWhen == 'onOver')   this.showCardActions = true;
    } 

    mouseleave(){
        if (this.showFooterWhen == 'onOver')   this.showCardActions = false;
    }

}

